import { chakra } from "@chakra-ui/react"

export const LoginImage = chakra((props: React.SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 491 405"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M359.775 305.834L316.066 304.982C314.487 304.978 312.974 304.346 311.862 303.226C310.749 302.106 310.129 300.59 310.136 299.012C310.259 295.726 313.018 293.158 316.306 293.271L360.02 294.119C361.599 294.124 363.112 294.757 364.224 295.878C365.337 296.998 365.957 298.515 365.95 300.094C365.825 303.38 363.064 305.947 359.775 305.834Z"
      fill="#1D2B47"
      stroke="#1D2B47"
      strokeLinecap="round"
    />
    <path
      d="M427.3 296.184C429.509 298.549 433.217 298.678 435.584 296.471L466.548 267.593C468.914 265.386 469.042 261.68 466.834 259.314C464.626 256.949 460.917 256.821 458.55 259.028L427.586 287.905C425.22 290.112 425.092 293.819 427.3 296.184Z"
      fill="#2B5FCE"
    />
    <path
      d="M427.3 296.184C429.509 298.549 433.217 298.678 435.584 296.471L466.548 267.593C468.914 265.386 469.042 261.68 466.834 259.314C464.626 256.949 460.917 256.821 458.55 259.028L427.586 287.905C425.22 290.112 425.092 293.819 427.3 296.184Z"
      fill="#1D2B47"
      stroke="#1D2B47"
      strokeLinecap="round"
    />
    <path
      d="M379.127 101.903L358.554 226.275L354.741 342.072L286.672 340.485L321.153 320.199C321.153 320.199 318.663 185.448 338.006 123.771C364.709 103.798 379.127 101.903 379.127 101.903V101.903Z"
      fill="#E8602A"
    />
    <path
      d="M220.547 101.424L229.231 82.1266L290.151 111.41C290.151 111.41 325.964 65.9446 339.539 55.439C344.596 51.5208 344.239 98.5388 344.239 98.5388L319.554 125.06C306.375 137.629 286.461 139.959 270.734 130.771L220.547 101.424Z"
      fill="#B99BF9"
    />
    <path
      d="M436.229 69.4608L435.028 127.552L413.931 129.369L408.079 66.1205L345.224 88.4149L352.472 51.7654L400.949 38.8844C409.297 36.6645 418.203 38.4161 425.087 43.6317C431.971 48.8474 436.064 56.9443 436.18 65.5769L436.229 69.4608Z"
      fill="#EEC493"
    />
    <path
      d="M199.373 75.7104C197.339 80.0155 199.343 85.2267 203.842 87.3474L212.928 91.6329L217.902 81.0881L199.373 75.7104Z"
      fill="#EEC493"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M199.373 75.7104C197.339 80.0155 199.343 85.2267 203.842 87.3474L212.928 91.6329L217.902 81.0881L199.373 75.7104Z"
      stroke="#1D2B47"
      strokeLinecap="round"
    />
    <path
      d="M202.537 79.178L207.565 80.9509C210.692 82.1313 211.927 85.8486 210.064 88.4346C208.935 89.9839 207.015 90.7462 205.129 90.3937L202.463 89.9039L202.091 95.5559L220.503 101.512L230.52 82.8708L211.397 70.0388C207.178 68.0455 202.214 69.7058 200.312 73.7366L197.578 79.5208L202.537 79.178Z"
      fill="#EEC493"
    />
    <path
      d="M229.128 82.0921L211.397 70.0388C207.178 68.0455 202.214 69.7058 200.312 73.7366L197.578 79.5208L202.537 79.1927L207.565 80.9509C210.692 82.1313 211.927 85.8486 210.065 88.4346C208.935 89.9839 207.015 90.7462 205.13 90.3937L202.464 89.9039L202.091 95.5559"
      stroke="#1D2B47"
      strokeLinecap="round"
    />
    <path
      d="M207.831 76.2883L193.06 87.9742C192.165 88.6543 190.895 88.519 190.164 87.6657C189.465 86.9012 189.482 85.7255 190.203 84.9817L203.018 71.9685L207.831 76.2883Z"
      fill="#EEC493"
    />
    <path
      d="M203.739 79.5939L193.06 87.9739C192.165 88.654 190.895 88.5186 190.164 87.6653C189.465 86.9008 189.482 85.7251 190.203 84.9814L200.984 74.0987C203.263 71.8759 206.692 71.3214 209.556 72.7126L214.157 74.8872"
      stroke="#1D2B47"
      strokeLinecap="round"
    />
    <path
      d="M187.551 97.5001L181.592 99.1849L184.4 93.9689L207.59 74.5593C208.467 73.8211 209.774 73.919 210.53 74.7797L210.869 75.1568C211.245 75.5832 211.433 76.1433 211.391 76.7103C211.348 77.2772 211.079 77.8031 210.643 78.1689L187.551 97.5001Z"
      fill="#1D2B47"
      stroke="#1D2B47"
      strokeLinecap="round"
    />
    <path
      d="M227.168 85.4519L210.099 88.4346C208.97 89.9839 207.05 90.7462 205.164 90.3937L202.498 89.9039L196.848 88.895C194.889 88.5013 192.98 89.7682 192.584 91.7259L192.369 92.8768L213.039 99.043L214.725 99.6259L220.224 99.1361L227.168 85.4519Z"
      fill="#EEC493"
    />
    <path
      d="M210.085 88.4348C208.956 89.9841 207.036 90.7464 205.15 90.3939L202.484 89.9041L196.834 88.8952C194.875 88.5015 192.967 89.7684 192.57 91.7261L192.355 92.877L220.523 101.512"
      stroke="#1D2B47"
      strokeLinecap="round"
    />
    <path
      d="M206.057 83.2087L210.82 85.4519"
      stroke="#1D2B47"
      strokeLinecap="round"
    />
    <path
      d="M229.231 82.1265L220.547 101.423L225.487 104.313L234.509 84.6635L229.231 82.1265Z"
      fill="#EEC493"
    />
    <path
      d="M339.54 55.4389C323.657 60.1407 290.152 111.41 290.152 111.41L243.165 88.8217L224.753 116.983L270.99 138.72C299.825 151.943 315.821 138.328 331.038 119.398L344.24 98.5436C344.24 98.5436 345.676 53.6219 339.54 55.4389Z"
      fill="white"
    />
    <path
      d="M252.298 93.4204L241.835 116.567C241.004 118.405 239.471 119.833 237.577 120.53C235.684 121.228 233.59 121.138 231.764 120.279L229.931 119.417"
      stroke="#1A1C35"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M339.538 55.4387C323.655 60.1405 290.15 111.41 290.15 111.41L243.163 88.8214L224.751 116.983L270.988 138.719C299.824 151.943 315.819 138.327 331.036 119.398L344.238 98.5434C344.238 98.5434 345.674 53.6216 339.538 55.4387V55.4387Z"
      stroke="#1A1C35"
    />
    <path
      d="M362.669 203.795H325.038C324.058 203.795 323.122 203.386 322.457 202.668C321.792 201.949 321.457 200.985 321.534 200.009L322.239 190.879C322.38 189.05 323.907 187.637 325.743 187.637H362.669V203.795Z"
      fill="white"
      stroke="#1A1C35"
    />
    <path
      d="M362.67 201.395L379.126 101.903C379.126 101.903 364.709 103.799 338.005 123.767C332.615 140.909 328.944 163.678 326.42 187.638H362.685L362.67 201.395Z"
      fill="#B99BF9"
      stroke="#1A1C35"
    />
    <path
      d="M324.896 203.79C320.069 261.456 321.152 320.194 321.152 320.194L286.672 340.48L354.741 342.067L358.554 226.275L362.273 203.8H324.896V203.79Z"
      fill="#EEC493"
      stroke="#1D2B47"
    />
    <path
      d="M222.596 110.611C222.062 111.768 222.011 113.089 222.453 114.284C222.895 115.478 223.795 116.448 224.953 116.978C226.111 117.511 227.432 117.561 228.627 117.119C229.822 116.678 230.792 115.779 231.324 114.623L233.818 109.186L225.487 104.323L222.596 110.611Z"
      fill="#1D2B47"
      stroke="#1D2B47"
    />
    <path
      d="M234.509 84.6631L225.487 104.313L233.813 109.181L243.164 88.8212L234.509 84.6631Z"
      fill="#EEC493"
    />
    <path
      d="M414.455 177.034L362.754 203.923C348.708 168.35 349.546 128.718 349.546 128.718L380.651 122.493L392.981 119.726L414.455 177.034Z"
      fill="#B99BF9"
      stroke="#1A1C35"
      strokeLinecap="round"
    />
    <path
      d="M392.882 119.697L372.887 66.8506C368.834 56.1361 357.5 50.0453 346.321 52.5737C334.752 55.1902 327.078 66.1788 328.61 77.9341L328.649 78.2377C329.117 82.068 327.343 85.8264 324.087 87.9009C319.493 90.8892 317.413 96.5407 318.974 101.792C320.534 107.043 325.364 110.643 330.845 110.641C331.515 110.64 332.184 110.584 332.844 110.474L335.726 132.617L392.882 119.697Z"
      fill="white"
    />
    <path
      d="M329.703 67.3697C328.514 70.7567 328.14 74.3757 328.61 77.9341L328.649 78.2377C329.117 82.068 327.343 85.8264 324.087 87.9009C319.493 90.8892 317.413 96.5407 318.974 101.792C320.534 107.043 325.364 110.643 330.845 110.641C331.515 110.64 332.184 110.584 332.844 110.474L335.726 132.617L392.882 119.697L372.887 66.8506C368.834 56.1361 357.5 50.0453 346.321 52.5737"
      stroke="#1D2B47"
      strokeLinecap="round"
    />
    <path
      d="M389.697 176.961C385.149 164.261 378.078 134.351 378.078 134.351C378.078 134.351 371.737 136.158 367.213 129.301"
      stroke="#1A1C35"
      strokeLinecap="round"
    />
    <path
      d="M443.501 80.3241L441.987 64.1616C439.537 43.8362 418.591 34.173 400.949 38.8601L351.806 52.0447L362.67 91.197L408.898 73.0216L412.127 109.882L446.28 113.668L443.501 80.3241Z"
      fill="white"
    />
    <path
      d="M441.482 109.882H435.391L435.195 119.476H441.482C444.074 119.393 446.131 117.27 446.131 114.679C446.131 112.088 444.074 109.964 441.482 109.882Z"
      fill="#1D2B47"
      stroke="#1D2B47"
      strokeLinecap="round"
    />
    <path
      d="M412.127 109.882L413.014 119.476H435.194L435.39 109.882H412.127Z"
      fill="#EEC493"
    />
    <path
      d="M375.113 86.3041L408.897 73.0215L412.127 109.882"
      stroke="#1D2B47"
    />
    <path
      d="M362.67 201.395L362.274 203.795H362.67V201.395Z"
      fill="white"
      stroke="#1A1C35"
    />
    <path
      d="M422.031 190.415L416.724 174.007C415.871 170.197 413.784 169.012 410.049 170.236L357.363 187.638C357.363 187.638 362.16 205.563 364.939 206.322C367.718 207.082 374.539 212.885 374.539 212.885"
      fill="white"
    />
    <path
      d="M422.031 190.415L416.724 174.007C415.871 170.197 413.784 169.012 410.049 170.236L357.363 187.638C357.363 187.638 362.16 205.563 364.939 206.322C367.718 207.082 374.539 212.885 374.539 212.885"
      stroke="#1A1C35"
    />
    <path
      d="M417.517 197.781C421.157 196.362 422.957 192.265 421.541 188.627C420.121 184.99 416.022 183.19 412.381 184.606L404.354 187.73L406.437 202.091L417.517 197.781Z"
      fill="#1D2B47"
      stroke="#1D2B47"
    />
    <path
      d="M489.352 294.721L407.913 212.263L406.443 202.091L404.36 187.73L362.759 203.922C364.479 208.32 366.442 212.618 368.64 216.798C371.923 223.094 375.894 229.008 380.479 234.43C413.941 273.509 450.348 304.012 450.348 304.012L442.737 336.586L489.352 294.721Z"
      fill="#EEC493"
      stroke="#1D2B47"
    />
    <path
      d="M225.488 104.323L222.596 110.621C222.062 111.778 222.011 113.099 222.453 114.294C222.895 115.488 223.795 116.458 224.953 116.988C226.111 117.52 227.432 117.571 228.627 117.129C229.822 116.688 230.792 115.789 231.324 114.633L243.272 88.9392"
      stroke="#1D2B47"
    />
    <path d="M229.143 82.092L245.178 89.7912" stroke="#1D2B47" />
    <path d="M220.523 101.516L233.755 108.941" stroke="#1D2B47" />
    <path
      d="M421.145 125.574L419.028 145.978C418.811 148.101 416.943 149.666 414.813 149.509L413.544 149.416L413.725 125.03L421.145 125.574Z"
      fill="#EEC493"
    />
    <path
      d="M413.724 125.03L413.542 149.416L414.812 149.509C416.941 149.666 418.809 148.101 419.026 145.978L419.634 140.101C419.634 140.101 426.353 141.614 431.983 134.919"
      stroke="#1D2B47"
      strokeLinecap="round"
    />
    <path
      d="M432.382 134.331L445.849 149.514C446.634 150.403 446.56 151.757 445.682 152.555C444.858 153.298 443.605 153.298 442.781 152.555L427.996 139.424L432.382 134.331Z"
      fill="#EEC493"
      stroke="#1D2B47"
      strokeLinecap="round"
    />
    <path
      d="M432.288 138.523L435.184 143.504L436.576 145.889L442.516 156.086C443.107 157.109 442.769 158.417 441.756 159.025C440.805 159.597 439.576 159.358 438.909 158.472L426.981 142.706L432.288 138.523Z"
      fill="#EEC493"
    />
    <path
      d="M435.611 144.224L436.591 145.87L442.531 156.067C443.122 157.09 442.784 158.397 441.771 159.006C440.82 159.577 439.591 159.338 438.924 158.452L426.996 142.687L432.303 138.514"
      stroke="#1D2B47"
      strokeLinecap="round"
    />
    <path
      d="M429.456 142.525L437.669 161.087C438.15 162.171 437.669 163.439 436.591 163.933C435.583 164.396 434.388 164.024 433.822 163.071L423.717 146.076L429.456 142.525Z"
      fill="#EEC493"
    />
    <path
      d="M431.685 147.56L437.669 161.087C438.15 162.171 437.669 163.439 436.591 163.933C435.583 164.396 434.388 164.024 433.822 163.071L423.717 146.076L429.456 142.525"
      stroke="#1D2B47"
      strokeLinecap="round"
    />
    <path
      d="M425.379 145.111L430.907 161.004C431.296 162.12 430.73 163.344 429.628 163.771C428.582 164.18 427.395 163.734 426.878 162.738L419.719 148.995L425.379 145.111Z"
      fill="#EEC493"
    />
    <path
      d="M437.894 140.537L420.492 150.361L415.214 140.85L413.572 123.546L434.645 126.563C437.454 130.421 438.639 135.224 437.948 139.944L437.894 140.537Z"
      fill="#EEC493"
    />
    <path
      d="M434.708 126.441C437.506 130.351 438.674 135.194 437.967 139.949L437.879 140.536"
      stroke="#1D2B47"
    />
    <path
      d="M413.597 138.754V123.571L412.205 109.902H441.481C444.073 109.985 446.13 112.108 446.13 114.699C446.13 117.29 444.073 119.414 441.481 119.496H435.194"
      stroke="#1D2B47"
    />
    <path
      d="M426.898 149.235L430.907 160.989C431.296 162.105 430.73 163.329 429.628 163.756C428.582 164.165 427.395 163.72 426.878 162.723L416.881 143.994"
      stroke="#1D2B47"
    />
    <path d="M435.39 109.882L435.165 127.048" stroke="#1D2B47" />
    <path
      d="M345.224 130.472V140.83C345.229 143.718 345.925 146.563 347.253 149.127L351.34 156.963"
      stroke="#1A1C35"
    />
    <path d="M344.479 187.638L347.939 150.268L344.479 187.638Z" fill="white" />
    <path d="M344.479 187.638L347.939 150.268" stroke="#1A1C35" />
    <path
      d="M489.352 294.721L460.183 265.188L434.239 289.716C435.749 291.104 437.171 292.4 438.508 293.605C445.467 299.898 447.147 307.975 444.266 316.884C440.973 327.056 432.647 336.827 441.355 342.969C446.226 346.422 489.352 294.721 489.352 294.721Z"
      fill="#1D2B47"
      stroke="#1D2B47"
    />
    <path
      d="M438.704 340.123L472.302 303.268C472.302 303.268 470.073 290.789 478.394 283.623L489.352 294.721C489.352 294.721 458.399 335.093 443.849 343.179C442.741 343.801 441.343 343.513 440.571 342.504C439.713 341.372 438.704 340.123 438.704 340.123Z"
      fill="white"
      stroke="#1D2B47"
    />
    <path
      d="M463.838 257.62C464.967 257.885 465.991 258.48 466.779 259.33C468.976 261.698 468.849 265.394 466.494 267.607L435.532 296.503C433.162 298.699 429.464 298.572 427.25 296.219C426.406 295.318 425.869 294.173 425.716 292.948"
      fill="#2B5FCE"
    />
    <path
      d="M425.74 292.933C425.893 294.158 426.43 295.304 427.274 296.205C429.487 298.558 433.186 298.685 435.556 296.489L466.518 267.593C468.872 265.38 468.999 261.684 466.802 259.316C466.014 258.466 464.99 257.87 463.862 257.606"
      fill="#1D2B47"
    />
    <path
      d="M425.74 292.933C425.893 294.158 426.43 295.304 427.274 296.205C429.487 298.558 433.186 298.685 435.556 296.489L466.518 267.593C468.872 265.38 468.999 261.684 466.802 259.316C466.014 258.466 464.99 257.87 463.862 257.606"
      stroke="#1D2B47"
      strokeLinecap="round"
    />
    <path
      d="M429.357 289.887L460.177 260.854L429.357 289.887Z"
      fill="#2B5FCE"
    />
    <path
      d="M429.357 289.887L460.177 260.854"
      stroke="#1D2B47"
      strokeLinecap="round"
    />
    <ellipse
      cx="5.30247"
      cy="5.29932"
      rx="5.30247"
      ry="5.29932"
      transform="matrix(-1 0 0 1 467.75 286.101)"
      fill="white"
    />
    <path
      d="M447.87 285.005C447.87 285.005 458.651 293.674 451.834 316.899C450.575 322.203 444.905 328.066 446.728 331.318"
      stroke="white"
    />
    <path
      d="M441.778 311.354C441.778 311.354 443.439 307.877 447.512 309.831"
      stroke="white"
    />
    <path
      d="M441.528 307.823C441.528 307.823 443.194 304.346 447.267 306.3"
      stroke="white"
    />
    <path
      d="M441.283 304.292C441.283 304.292 442.945 300.819 447.017 302.773"
      stroke="white"
    />
    <path
      d="M438.707 307.21C438.707 307.21 428.509 302.548 428.71 306.843C428.911 311.138 436.061 310.688 434.899 308.68C433.738 306.672 428.631 308.983 429.043 312.392C429.454 315.801 435.629 313.171 439.158 309.547"
      stroke="#1D2B47"
    />
    <path
      d="M357.167 341.181L356.828 299.683L319.961 299.193C320.079 301.24 320.198 303.162 320.319 304.957C320.946 314.317 316.398 321.277 307.817 325.67C298.055 330.675 284.853 331.88 286.887 342.351C288.024 348.229 357.167 341.181 357.167 341.181Z"
      fill="#1D2B47"
      stroke="#1D2B47"
    />
    <path
      d="M286.955 338.473L338.411 335.431C338.411 335.431 345.762 324.931 357.058 325.587L357.186 341.181C357.186 341.181 305.205 348.582 288.611 344.247C287.351 343.951 286.51 342.761 286.651 341.475C286.822 340.079 286.955 338.473 286.955 338.473Z"
      fill="white"
      stroke="#1D2B47"
    />
    <path
      d="M364.983 296.803C365.64 297.775 365.983 298.926 365.963 300.099C365.838 303.386 363.077 305.952 359.788 305.839L316.08 304.987C314.501 304.983 312.988 304.352 311.875 303.231C310.763 302.111 310.142 300.595 310.15 299.017C310.17 297.771 310.599 296.567 311.37 295.588"
      fill="#2B5FCE"
    />
    <path
      d="M311.356 295.597C310.585 296.576 310.156 297.78 310.136 299.026C310.128 300.604 310.749 302.12 311.861 303.24C312.974 304.361 314.486 304.992 316.066 304.996L359.774 305.848C363.063 305.961 365.824 303.395 365.949 300.108C365.968 298.935 365.626 297.784 364.969 296.812"
      fill="#1D2B47"
    />
    <path
      d="M311.356 295.597C310.585 296.576 310.156 297.78 310.136 299.026C310.128 300.604 310.749 302.12 311.861 303.24C312.974 304.361 314.486 304.992 316.066 304.996L359.774 305.848C363.063 305.961 365.824 303.395 365.949 300.108C365.968 298.935 365.626 297.784 364.969 296.812"
      stroke="#1D2B47"
      strokeLinecap="round"
    />
    <path d="M316.222 295.931L359.94 296.567L316.222 295.931Z" fill="#2B5FCE" />
    <path
      d="M316.222 295.931L359.94 296.567"
      stroke="#1D2B47"
      strokeLinecap="round"
    />
    <ellipse
      cx="5.47889"
      cy="5.29932"
      rx="5.47889"
      ry="5.29932"
      transform="matrix(-1 0 0 1 345.116 314.762)"
      fill="white"
    />
    <path
      d="M333.447 305.32C333.447 305.32 335.197 319.034 313.428 330.96C308.675 333.898 300.256 334.143 299.266 337.748"
      stroke="white"
    />
    <path
      d="M309.987 319.978C309.987 319.978 313.722 318.641 315.329 322.883"
      stroke="white"
    />
    <path
      d="M312.326 317.275C312.326 317.275 316.06 315.938 317.667 320.175"
      stroke="white"
    />
    <path
      d="M314.683 314.566C314.683 314.566 318.422 313.234 320.024 317.471"
      stroke="white"
    />
    <path
      d="M310.678 314.865C310.678 314.865 306.478 304.423 303.538 307.641C300.598 310.859 306.228 315.526 306.802 313.269C307.375 311.011 301.94 309.125 299.789 311.853C297.638 314.581 304.106 316.996 309.326 316.883"
      stroke="#1D2B47"
    />
    <path
      d="M411.69 101.046L436.08 100.601C438.376 100.199 440.735 100.778 442.585 102.195C444.434 103.613 445.605 105.74 445.813 108.06"
      stroke="#1D2B47"
    />
    <path
      d="M373.26 22.9472C373.054 22.9906 372.852 23.0446 372.652 23.1088L371.829 19.2396C371.225 16.3916 369.514 13.8998 367.072 12.3126C364.63 10.7254 361.657 10.1728 358.808 10.7764L349.781 12.6963L352.437 25.205C354.102 33.0248 361.793 38.0166 369.619 36.3571L375.215 35.167V35.1376C375.421 35.1376 375.632 35.0788 375.837 35.0347C378.048 34.6236 379.862 33.0464 380.575 30.9147C381.289 28.7831 380.789 26.4327 379.27 24.7752C377.751 23.1178 375.452 22.4142 373.265 22.9374L373.26 22.9472Z"
      fill="#B99BF9"
      stroke="#1D2B47"
    />
    <ellipse
      cx="4.79771"
      cy="4.79485"
      rx="4.79771"
      ry="4.79485"
      transform="matrix(-1 0 0 1 355.152 10.6245)"
      fill="#B99BF9"
      stroke="#1D2B47"
    />
    <path
      d="M346.597 28.0901L353.35 50.1445L340.123 58.3726L334.291 30.965"
      fill="#EEC493"
    />
    <path
      d="M340.122 58.3722L334.29 30.9646"
      stroke="#1D2B47"
      strokeLinecap="round"
    />
    <path
      d="M336.266 40.2459C336.266 40.2459 340.049 39.8051 342.397 37.4983C342.549 41.8572 337.888 47.8814 337.888 47.8814L336.266 40.2459Z"
      fill="#1D2B47"
    />
    <ellipse
      cx="9.97766"
      cy="9.97173"
      rx="9.97766"
      ry="9.97173"
      transform="matrix(-1 0 0 1 346.836 20.3174)"
      fill="#EEC493"
    />
    <path
      d="M342.598 38.4485C341.5 39.2245 340.254 39.7663 338.937 40.0403C333.547 41.1858 328.249 37.7475 327.102 32.3607C325.956 26.9738 329.396 21.6783 334.787 20.5327"
      stroke="#1D2B47"
      strokeLinecap="round"
    />
    <path
      d="M351.346 25.3129L349.018 35.8381C349.018 35.8381 343.829 36.9401 342.157 30.3233C345.098 28.4083 342.648 24.0297 340.565 25.2444C338.482 26.459 339.844 31.6114 339.844 31.6114C339.844 31.6114 338.992 31.4644 337.977 28.2613C337.457 26.6309 335.813 25.6339 334.125 25.9251C330.744 26.4492 326.373 24.6419 323.31 21.145C321.621 19.2316 320.455 16.9156 319.923 14.4204C326.417 12.9021 333.802 11.3447 339.237 10.2329C342.76 9.48409 346.423 10.5667 348.972 13.1101C351.52 15.6535 352.609 19.3126 351.866 22.8347L351.346 25.3129Z"
      fill="#B99BF9"
      stroke="#1D2B47"
    />
    <path
      d="M349.017 35.8381L353.35 50.1443"
      stroke="#1D2B47"
      strokeLinecap="round"
    />
    <path
      d="M372.894 23.0256L366.219 24.4411L372.894 23.0256Z"
      fill="#B99BF9"
    />
    <path
      d="M372.894 23.0256L366.219 24.4411"
      stroke="#1D2B47"
      strokeLinecap="round"
    />
    <path
      d="M446.281 113.668L443.502 80.3631L441.988 64.2007C439.538 43.8752 418.592 34.212 400.95 38.8991L352.566 51.8291"
      stroke="#1D2B47"
      strokeLinecap="round"
    />
    <path
      d="M336.904 62.418L334.453 54.7335C334.302 54.2307 334.359 53.6884 334.611 53.228C334.864 52.7676 335.291 52.4278 335.796 52.2846L352.909 47.3428C353.418 47.1932 353.966 47.2561 354.428 47.5173C354.89 47.7785 355.226 48.2157 355.359 48.7289L356.462 52.8576"
      fill="white"
    />
    <path
      d="M336.904 62.418L334.453 54.7335C334.302 54.2307 334.359 53.6884 334.611 53.228C334.864 52.7676 335.291 52.4278 335.796 52.2846L352.909 47.3428C353.418 47.1932 353.966 47.2561 354.428 47.5173C354.89 47.7785 355.226 48.2157 355.359 48.7289L356.462 52.8576"
      stroke="#1D2B47"
      strokeLinecap="round"
    />
    <path
      d="M242.748 63.6387L228.602 47.7305L178.961 94.1573C178.961 94.1573 129.342 60.1015 113.159 54.0996C107.124 51.8638 123.158 98.0653 123.158 98.0653L154.837 116.089C171.272 124.177 191.079 120.419 203.405 106.874L242.748 63.6387Z"
      fill="#EEC493"
      stroke="#1D2B47"
    />
    <path
      d="M267.112 42.5253L267.826 36.5184L259.75 26.372C258.731 25.0909 257.148 24.3908 255.514 24.4988C253.88 24.6068 252.403 25.509 251.561 26.9131L241.521 43.6611L245.756 57.0585L263.297 57.1393L264.174 56.0054C266.686 52.7604 258.779 52.2258 258.297 48.1535L267.112 42.5253Z"
      fill="#EEC493"
    />
    <path
      d="M254.516 51.9318C258.348 48.6874 259.632 46.6584 260.863 41.3943"
      stroke="#1D2B47"
      strokeLinecap="round"
    />
    <path
      d="M272.63 64.6252L238.151 13.7829C237.466 12.7751 236.227 12.2984 235.043 12.5873L211.482 18.3304C210.547 18.5553 209.784 19.2277 209.445 20.1265L184.933 84.5434C184.549 85.5508 184.752 86.6879 185.463 87.4993C186.173 88.3108 187.273 88.664 188.323 88.4174L270.865 69.0997C271.802 68.8837 272.572 68.2206 272.925 67.3266C273.278 66.4326 273.168 65.4223 272.63 64.6252Z"
      fill="#1D2B47"
      stroke="#1D2B47"
    />
    <path
      d="M285.989 61.1849L240.272 15.3548C239.565 14.6441 238.541 14.3473 237.562 14.569C236.584 14.7907 235.788 15.4997 235.456 16.446L213.953 77.4588C213.6 78.4588 213.819 79.5715 214.524 80.364C215.229 81.1564 216.309 81.5035 217.344 81.2702L284.563 66.0874C285.598 65.8527 286.424 65.0749 286.721 64.056C287.017 63.0372 286.737 61.9378 285.989 61.1849Z"
      fill="#E9F0FB"
      stroke="#1D2B47"
    />
    <path
      d="M94.4843 102.226L109.853 228.078L108.761 344.601L177.23 345.903L143.445 324.047C143.445 324.047 151.677 188.751 134.871 125.95C108.889 104.746 94.4843 102.226 94.4843 102.226Z"
      fill="white"
      stroke="#1D2B47"
    />
    <path
      d="M102.741 231.586L94.4837 102.226C94.4837 102.226 108.888 104.746 134.86 125.95C145.9 167.201 146.136 239.736 144.987 284.655L96.8954 289.988L102.741 231.586Z"
      fill="white"
      stroke="#1D2B47"
    />
    <path
      d="M104.52 284.657H109.314L109.162 300.907H104.52C102.364 300.908 100.295 300.052 98.7705 298.528C97.2457 297.004 96.3895 294.937 96.3904 292.782C96.3904 288.295 100.03 284.657 104.52 284.657Z"
      fill="#1D2B47"
      stroke="#1D2B47"
    />
    <path
      d="M108.717 337.79L109.161 300.917L109.314 284.667H144.983C144.83 290.615 144.655 296.075 144.477 300.917C143.957 315.182 143.415 324.06 143.415 324.06L165.527 337.801L108.717 337.79Z"
      fill="#EEC493"
      stroke="#1D2B47"
    />
    <path
      d="M69.7134 189.185L81.7826 86.0322L116.975 120.815C116.975 120.815 121.995 186.684 99.1225 225.967C88.3155 244.529 76.57 261.593 66.5451 275.229L21.8585 254.693L69.7134 189.185Z"
      fill="white"
    />
    <path
      d="M117.219 153.439C115.967 175.614 111.762 204.697 99.3948 225.967C88.5842 244.529 76.8424 261.593 66.8138 275.229L22.1308 254.693L69.9675 189.185L82.0367 86.0322L117.222 120.815"
      stroke="#1D2B47"
    />
    <path
      d="M24.5827 265.65C22.8137 264.418 21.6071 262.533 21.2285 260.412C20.8499 258.29 21.3303 256.105 22.5639 254.337C25.1318 250.658 30.1975 249.755 33.8801 252.32L36.5864 254.181L27.2781 267.504L24.5827 265.65Z"
      fill="#1D2B47"
      stroke="#1D2B47"
    />
    <path
      d="M1.66671 304.183L27.2856 267.503L36.5866 254.179L66.7778 275.224C63.2604 280.001 59.9539 284.356 56.9566 288.199C47.9465 299.806 41.8756 306.779 41.8756 306.779L48.4485 334.378L1.66671 304.183Z"
      fill="#EEC493"
      stroke="#1D2B47"
    />
    <path
      d="M171.591 89.1368L171.086 91.2926V88.7878L171.591 89.1368Z"
      fill="white"
      stroke="#1D2B47"
    />
    <path
      d="M151.53 113.517L123.158 98.0668C123.158 98.0668 107.109 51.8508 113.144 54.0793C121.51 57.173 137.653 66.952 150.49 75.1642L151.53 113.517Z"
      fill="#C9B3FF"
      stroke="#1D2B47"
    />
    <path
      d="M76.8241 130.565L135.751 128.809L128.949 73.7662C127.488 61.9303 117.251 53.152 105.324 53.5065C93.7992 53.8437 84.2858 62.6178 83.026 74.0715L76.8241 130.565Z"
      fill="#C9B3FF"
    />
    <path
      d="M105.314 53.5066C93.7933 53.8492 84.2861 62.6219 83.0269 74.0717L76.8431 130.561L135.771 128.805L128.685 71.6178"
      stroke="#1D2B47"
    />
    <path
      d="M189.663 90.4481L192.209 32.061L171.152 28.8801L161.203 91.9749L113.188 71.3662L112.679 104.121L152.328 118.869C169.729 124.707 187.975 112.631 189.404 94.3379L189.663 90.4481Z"
      fill="#EEC493"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M189.663 90.4481L192.209 32.061L171.152 28.8801L161.203 91.9749L115.709 72.3805L116.218 105.389L152.295 118.869C169.697 124.707 187.942 112.631 189.372 94.3379L189.663 90.4481Z"
      stroke="#1D2B47"
    />
    <path
      d="M178.161 35.7196L184.759 16.1688C185.442 14.1381 184.389 11.9325 182.38 11.1847L181.18 10.7412L175.309 16.9685C173.549 18.8338 172.394 21.1868 171.995 23.7193L170.322 34.3054L178.161 35.7196Z"
      fill="#EEC493"
    />
    <path
      d="M181.18 10.731L175.309 16.9583C173.549 18.8235 172.394 21.1766 171.996 23.7091L170.322 34.2952"
      stroke="#1A1C35"
      strokeLinecap="round"
    />
    <path
      d="M181.179 10.731L182.379 11.1817C184.392 11.9295 185.445 14.1402 184.758 16.173L182.863 21.786C182.863 21.786 189.64 23.2074 191.99 31.685"
      stroke="#1A1C35"
      strokeLinecap="round"
    />
    <path
      d="M199.727 29.0277L187.09 13.7339L180.23 16.7803L171.085 34.5534L190.943 40.4608C195.121 38.1042 198.21 34.2045 199.545 29.5985L199.727 29.0277Z"
      fill="#EEC493"
    />
    <path
      d="M190.931 40.5923C195.121 38.1806 198.21 34.2362 199.545 29.5917L199.712 29.021"
      stroke="#1A1C35"
      strokeLinecap="round"
    />
    <path
      d="M189.244 20.3899L203.339 11.0144C204.329 10.3552 204.619 9.03187 203.997 8.01886C203.404 7.06129 202.185 6.70273 201.167 7.18637L187.068 13.839L189.244 20.3899Z"
      fill="#EEC493"
    />
    <path
      d="M192.968 18.0088L203.339 11.0144C204.329 10.3552 204.619 9.03187 203.997 8.01886C203.404 7.06129 202.185 6.70273 201.167 7.18637L181.769 16.1147"
      stroke="#1A1C35"
      strokeLinecap="round"
    />
    <path
      d="M190.579 23.1387L208.73 13.7632C209.788 13.2152 210.21 11.9208 209.68 10.8549C209.181 9.85822 208.011 9.39735 206.966 9.78611L188.328 16.7369L190.579 23.1387Z"
      fill="#EEC493"
    />
    <path
      d="M195.508 20.594L208.73 13.7632C209.788 13.2152 210.21 11.9208 209.68 10.8549C209.181 9.85822 208.011 9.39735 206.966 9.78611L188.328 16.7369"
      stroke="#1A1C35"
      strokeLinecap="round"
    />
    <path
      d="M192.001 26.819L197.315 24.5469L199.861 23.4563L210.774 18.7849C211.87 18.3145 212.385 17.0516 211.93 15.9493C211.505 14.9191 210.371 14.3751 209.301 14.6879L190.218 20.2754L192.001 26.819Z"
      fill="#EEC493"
    />
    <path
      d="M198.089 24.2056L199.857 23.4495L210.769 18.7781C211.866 18.3077 212.381 17.0448 211.926 15.9425C211.501 14.9123 210.367 14.3683 209.296 14.681L190.217 20.2722"
      stroke="#1A1C35"
      strokeLinecap="round"
    />
    <path
      d="M191.731 31.9547L210.799 24.6113C211.911 24.1823 212.473 22.941 212.061 21.823C211.675 20.7765 210.561 20.1899 209.479 20.4634L190.2 25.342L191.731 31.9547Z"
      fill="#EEC493"
    />
    <path
      d="M199.792 28.9669L210.799 24.6045C211.911 24.1755 212.473 22.9341 212.061 21.8162C211.675 20.7697 210.561 20.1831 209.479 20.4566L193.801 24.4191"
      stroke="#1A1C35"
    />
    <path
      d="M270.256 37.0439C271.451 38.8226 271.299 41.182 269.886 42.793L265.522 47.7489C264.791 48.627 263.496 48.7699 262.591 48.0724C261.731 47.4095 261.51 46.2052 262.078 45.2803L266.983 33.5669L270.256 37.0439Z"
      fill="#EEC493"
      stroke="#1D2B47"
    />
    <path
      d="M266.713 33.2575C267.967 34.6241 268.13 36.667 267.111 38.2154L262.288 45.5558C261.643 46.6196 260.271 46.9829 259.184 46.378C258.141 45.8099 257.699 44.5439 258.162 43.4509L262.646 29.3577L266.713 33.2575Z"
      fill="#EEC493"
      stroke="#1D2B47"
    />
    <path
      d="M262.675 29.3442C264.055 30.6948 264.434 32.7686 263.62 34.5195L259.409 43.4934C258.9 44.6269 257.585 45.1558 256.432 44.6909C255.338 44.2482 254.573 42.3693 254.883 41.2474L256.548 28.7344C256.711 27.8325 257.361 27.095 258.235 26.8182C259.11 26.5415 260.065 26.771 260.718 27.4145L262.675 29.3442Z"
      fill="#EEC493"
    />
    <path
      d="M259.224 25.7944L262.68 29.3361C264.06 30.6868 264.439 32.7605 263.625 34.5114L259.414 43.4854C258.905 44.6189 257.59 45.1477 256.437 44.6829C255.342 44.2387 254.758 43.0408 255.083 41.9051L258.02 32.556"
      stroke="#1D2B47"
      strokeLinecap="round"
    />
    <path
      d="M259.195 25.9294C260.576 27.2794 260.955 29.3539 260.14 31.1046L255.934 40.0778C255.424 41.2129 254.107 41.7421 252.952 41.2761C251.858 40.8334 251.223 38.8577 251.543 37.724L254.536 29.6124L254.348 26.6152L259.195 25.9294Z"
      fill="#EEC493"
    />
    <path
      d="M259.195 25.9254C260.576 27.2755 260.955 29.3499 260.14 31.1006L255.934 40.0738C255.424 41.2089 254.107 41.7381 252.952 41.2721C251.859 40.8266 251.275 39.6299 251.598 38.4943L254.542 29.1364"
      stroke="#1D2B47"
      strokeLinecap="round"
    />
    <path
      d="M152.284 118.868C154.018 119.451 155.806 119.865 157.62 120.104V122.419C157.539 125.727 154.833 128.367 151.522 128.367C148.211 128.367 145.504 125.727 145.424 122.419V116.603L152.284 118.868Z"
      fill="#1D2B47"
      stroke="#1D2B47"
    />
    <path
      d="M108.583 66.0273L145.424 85.2146V122.397L149.236 127.984L104.266 107.925"
      fill="#C9B3FF"
    />
    <path
      d="M108.583 66.0273L145.424 85.2146V122.397L149.236 127.984L104.266 107.925"
      stroke="#1D2B47"
    />
    <path
      d="M149.924 325.728L160.753 328.538C166.672 330.077 171.609 334.149 174.244 339.665L177.216 345.893L108.747 344.591L109.002 318.755H118.663L123.577 315.418C126.379 313.522 129.684 312.509 133.068 312.51H144.02C143.936 314.327 143.86 315.959 143.787 317.381C143.595 321.265 146.158 324.75 149.924 325.728Z"
      fill="white"
      stroke="#1D2B47"
      strokeLinecap="round"
    />
    <path
      d="M157.872 327.814L160.753 328.541C166.672 330.08 171.609 334.152 174.244 339.669L177.216 345.896L108.747 344.594L108.813 337.851L153.554 338.745C154.689 338.768 155.785 338.333 156.596 337.539C157.406 336.745 157.864 335.659 157.864 334.525L157.872 327.814Z"
      fill="#1D2B47"
      stroke="#1D2B47"
      strokeLinecap="round"
    />
    <path
      d="M123.493 319.612C123.493 319.612 124.613 331.812 154.462 332.957L123.493 319.612Z"
      fill="white"
    />
    <path
      d="M123.493 319.612C123.493 319.612 124.613 331.812 154.462 332.957"
      stroke="#1D2B47"
      strokeLinecap="round"
    />
    <path
      d="M155.14 322.904C155.14 322.904 150.862 323.631 151.699 328.622"
      stroke="#1D2B47"
      strokeLinecap="round"
    />
    <path
      d="M151.4 321.536C151.4 321.536 147.123 322.245 147.963 327.251"
      stroke="#1D2B47"
      strokeLinecap="round"
    />
    <path
      d="M147.665 320.155C147.665 320.155 143.383 320.864 144.223 325.873"
      stroke="#1D2B47"
      strokeLinecap="round"
    />
    <path
      d="M151.622 318.29C151.622 318.29 149.782 305.821 154.361 307.384C158.941 308.948 156.206 316.542 154.401 314.655C152.597 312.768 156.7 307.984 160.254 309.496C163.808 311.009 159.032 316.851 154.009 319.523"
      stroke="#1D2B47"
      strokeLinecap="round"
    />
    <path
      d="M45.4394 312.979L52.5907 321.591C56.491 326.3 58.1124 332.489 57.0211 338.503L55.788 345.29L1.01103 304.211L16.3249 283.409L24.16 289.055L30.1001 289.222C33.4802 289.32 36.7532 290.43 39.4957 292.407L48.3821 298.805C47.2472 300.234 46.2323 301.513 45.3412 302.622C42.9167 305.663 42.9577 309.985 45.4394 312.979Z"
      fill="white"
      stroke="#1D2B47"
      strokeLinecap="round"
    />
    <path
      d="M50.6812 319.3L52.5799 321.591C56.4803 326.299 58.1016 332.488 57.0104 338.502L55.7773 345.289L1.00029 304.21L5.00153 298.779L40.7763 325.659C41.6839 326.341 42.8282 326.63 43.9511 326.459C45.074 326.289 46.0811 325.674 46.7454 324.753L50.6812 319.3Z"
      fill="#1D2B47"
      stroke="#1D2B47"
      strokeLinecap="round"
    />
    <path
      d="M27.5801 292.553C27.5801 292.553 21.3563 303.124 44.8945 321.483L27.5801 292.553Z"
      fill="white"
    />
    <path
      d="M27.5801 292.553C27.5801 292.553 21.3563 303.124 44.8945 321.483"
      stroke="#1D2B47"
      strokeLinecap="round"
    />
    <path
      d="M51.3247 313.739C51.3247 313.739 47.4399 311.812 45.1919 316.364"
      stroke="#1D2B47"
      strokeLinecap="round"
    />
    <path
      d="M49.0991 310.44C49.0991 310.44 45.2106 308.514 42.9627 313.065"
      stroke="#1D2B47"
      strokeLinecap="round"
    />
    <path
      d="M46.8687 307.138C46.8687 307.138 42.9802 305.211 40.7322 309.766"
      stroke="#1D2B47"
      strokeLinecap="round"
    />
    <path
      d="M51.172 307.935C51.172 307.935 56.9556 296.745 59.7746 300.69C62.5937 304.634 55.9153 309.196 55.5661 306.601C55.2169 304.005 61.3278 302.533 63.3285 305.837C65.3291 309.142 58.0468 311.094 52.3942 310.32"
      stroke="#1D2B47"
      strokeLinecap="round"
    />
    <path
      d="M123.483 62.3255C120.391 66.8624 111.21 65.9972 102.971 60.3915C100.821 58.9348 98.8657 57.2112 97.1508 55.2621C99.7478 54.1832 102.52 53.5882 105.332 53.5062C107.65 53.4376 109.965 53.7182 112.199 54.3387C112.418 54.0232 112.838 53.9203 113.178 54.0988C116.131 55.1894 120.063 57.127 124.483 59.53C124.392 60.5314 124.048 61.4934 123.483 62.3255Z"
      fill="#EEC493"
      stroke="#1D2B47"
    />
    <path
      d="M134.413 14.813C134.413 14.813 139.119 29.6851 124.89 33.2405C119.048 31.9681 125.144 18.2593 125.144 18.2593L134.413 14.813Z"
      fill="#1D2B47"
      stroke="#1D2B47"
    />
    <path
      d="M106.091 31.9761L104.058 55.0822L118.793 60.4153V32.2305"
      fill="#EEC493"
    />
    <path d="M118.793 60.4152V32.2305" stroke="#1D2B47" strokeLinecap="round" />
    <path
      d="M106.091 31.9761L104.057 55.0822"
      stroke="#1D2B47"
      strokeLinecap="round"
    />
    <path
      d="M118.793 41.7781C118.793 41.7781 114.981 42.1416 112.188 40.3567C112.952 44.6755 118.793 49.6304 118.793 49.6304V41.7781Z"
      fill="#1D2B47"
    />
    <ellipse
      cx="10.0358"
      cy="10.0299"
      rx="10.0358"
      ry="10.0299"
      transform="matrix(-1 0 0 1 126.163 22.0767)"
      fill="#EEC493"
    />
    <path
      d="M112.187 41.3578C115.933 42.9494 120.27 42.1229 123.167 39.2653C126.064 36.4077 126.948 32.0846 125.405 28.3203C123.862 24.5559 120.197 22.0953 116.127 22.0906"
      stroke="#1D2B47"
      strokeLinecap="round"
    />
    <path
      d="M105.334 40.1016C105.334 40.1016 110.67 40.1016 110.925 33.249C107.622 31.9767 109.146 27.1526 111.431 27.916C113.715 28.6794 113.464 34.0088 113.464 34.0088C113.464 34.0088 115.497 31.2169 114.988 26.1383H127.141C131.364 26.1283 134.782 22.7029 134.78 18.4823C134.78 8.83419 126.959 1.01003 117.305 1C103.81 1 93.8362 13.6619 97.1099 26.7454C98.3321 31.6313 100.806 36.3718 105.334 40.1016Z"
      fill="#1D2B47"
      stroke="#1D2B47"
    />
    <path
      d="M104.17 140.714C104.17 140.714 101.33 146.963 94.5092 146.963C93.5271 156.778 89.0093 182.487 86.3176 197.414C84.9932 204.753 82.2143 211.754 78.1441 218.004L48.9533 262.806"
      stroke="#1D2B47"
    />
    <path
      d="M116.476 163.429L123.103 223.249C123.36 225.585 123.513 227.93 123.562 230.283L124.653 284.653"
      stroke="#1D2B47"
    />
    <path
      d="M297.479 236.501L290.712 212.206C290.577 211.724 290.157 211.377 289.658 211.334L279.737 210.49C279.343 210.456 278.959 210.618 278.709 210.923L260.739 232.792C260.458 233.134 260.388 233.603 260.559 234.011C260.729 234.42 261.111 234.701 261.552 234.743L296.206 238.012C296.599 238.05 296.986 237.893 297.24 237.591C297.494 237.289 297.584 236.882 297.479 236.501Z"
      fill="#1D2B47"
      stroke="#1D2B47"
    />
    <path
      d="M303.129 236.909L291.332 213.097C291.149 212.727 290.79 212.478 290.38 212.436C289.97 212.395 289.568 212.567 289.315 212.892L272.962 233.829C272.693 234.172 272.633 234.633 272.804 235.034C272.974 235.434 273.349 235.711 273.783 235.755L301.932 238.631C302.366 238.675 302.789 238.48 303.038 238.122C303.286 237.765 303.321 237.3 303.129 236.909Z"
      fill="#E9F0FB"
      stroke="#1D2B47"
    />
    <path
      d="M159.99 259.987L164.213 229.621L183.704 220.729L322.114 270.359L304.007 279.989L159.99 259.987Z"
      fill="#1D2B47"
      stroke="#1D2B47"
    />
    <rect
      x="0.426383"
      y="0.564018"
      width="145.061"
      height="30.433"
      transform="matrix(0.990492 0.137567 -0.137727 0.99047 183.298 219.608)"
      fill="white"
      stroke="#1D2B47"
    />
    <ellipse
      cx="245.253"
      cy="295.604"
      rx="26.5386"
      ry="31.6968"
      fill="#B99BF9"
      stroke="#1D2B47"
      strokeLinecap="round"
    />
    <path
      d="M218.709 295.6C218.99 271.318 248.805 268.387 263.911 274.269C258.24 260.595 227.188 254.908 212.629 277.865C205.529 288.623 205.529 302.576 212.629 313.334C219.729 324.092 232.563 329.584 245.253 327.296C229.895 324.544 218.715 311.193 218.709 295.6Z"
      fill="#1D2B47"
      stroke="#1D2B47"
      strokeLinecap="round"
    />
    <path d="M189.352 404.751L189.415 328.223H255.363V404.751" fill="#1D2B47" />
    <path d="M219.468 404.469V328.381H295.599V404.469" fill="#EEC493" />
    <path
      d="M219.468 404.469V328.381H295.599V404.469H219.468Z"
      stroke="#1D2B47"
      strokeLinecap="round"
    />
    <path
      d="M205.436 221.613L192.781 97.4685L262.054 90.3782L274.775 214.516"
      fill="#1D2B47"
    />
    <path
      d="M238.596 217.729L226.012 94.9351L301.747 87.1833L314.331 209.977"
      fill="#82ABF7"
    />
    <path
      d="M238.596 217.729L226.012 94.9351L301.747 87.1833L314.331 209.977L238.596 217.729Z"
      stroke="#1D2B47"
      strokeLinecap="round"
    />
  </svg>
))
